// extracted by mini-css-extract-plugin
export default {"footer":"banner3_page_footer__qEwgl"};